export const formItems = {
	housePrice: 'housePrice',
	mortgage: 'mortgage',
	step3: {
		reasonForCalculation: {
			title: 'Om de bijkomende kosten goed uit te rekenen, willen we eerst weten wat je van plan bent met je woning.',
			label: 'Wat zijn je plannen?',
			name: 'reasonForCalculation',
			options: {
				sell: {
					label: 'Nieuwe woning aankopen',
					value: 'sell',
				},
				remodel: {
					label: 'Huidige woning verbouwen en/of verduurzamen',
					value: 'remodel',
				},
			}
		},
		administration: {
			name: 'administration',
			label: 'Advies- en bemiddelingskosten*',
			tooltip: 'De advies- en bemiddelingskosten betaal je aan je financieel adviseur voor het oversluiten van de hypotheek. De kosten hiervoor liggen meestal tussen de € 2.500 en € 3.500.',
			defaultValue: '€ 2.990',
			error: 'Vul de advies- en bemiddelingskosten in.',
		},
		taxationCurrent: {
			name: 'taxationCurrent',
			label: 'Taxatiekosten huidige woning*',
			tooltip: 'Over het algemeen kun je uitgaan van een bedrag van tussen de € 550 en € 1.000, afhankelijk van het aantal uren dat een taxateur aan een rapport kwijt is.',
			defaultValue: '€ 700',
			error: 'Vul de taxatiekosten in.',
		},
		taxationNew: {
			name: 'taxationNew',
			label: 'Taxatiekosten nieuwe woning*',
			tooltip: 'Over het algemeen kun je uitgaan van een bedrag van tussen de € 550 en € 1.000, afhankelijk van het aantal uren dat een taxateur aan een rapport kwijt is.',
			defaultValue: '€ 700',
			error: 'Vul de taxatiekosten in.',
		},
		estateAgent: {
			name: 'estateAgent',
			label: 'Makelaarskosten*',
			tooltip: 'Bij het verkopen van je woning heb je o.a. te maken met makelaarskosten. Gemiddeld komt dit neer op een percentage van 2% van de verkoopprijs.',
			error: 'Vul de makelaarskosten in.',
		},
		notary: {
			name: 'notary',
			label: 'Notariskosten*',
			defaultValue: { selling: '€ 1.400', remodeling: '€ 700' },
			tooltip: 'De gemiddelde kosten voor de notaris zijn {notaryCosts} (akte van levering en hypotheekakte). De werkelijke kosten kunnen afwijken, vraag daarom altijd een offerte aan bij verschillende notariskantoren.',
			error: 'Vul de notariskosten in.',

		},
	}
};

